var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 13.5938C8.59835 13.5938 7.96875 14.2233 7.96875 15V22.875C7.96875 23.6517 8.59835 24.2812 9.375 24.2812H20.625C21.4017 24.2812 22.0312 23.6517 22.0312 22.875V15C22.0312 14.2233 21.4017 13.5938 20.625 13.5938H9.375ZM6.28125 15C6.28125 13.2914 7.66637 11.9062 9.375 11.9062H20.625C22.3336 11.9062 23.7188 13.2914 23.7188 15V22.875C23.7188 24.5836 22.3336 25.9688 20.625 25.9688H9.375C7.66637 25.9688 6.28125 24.5836 6.28125 22.875V15Z",
    fill: "#1E1542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.875 5.71875C11.8547 5.71875 10.2188 7.35474 10.2188 9.375V12.75C10.2188 13.216 9.84099 13.5938 9.375 13.5938C8.90901 13.5938 8.53125 13.216 8.53125 12.75V9.375C8.53125 6.42276 10.9228 4.03125 13.875 4.03125H16.125C19.0772 4.03125 21.4688 6.42276 21.4688 9.375V12.75C21.4688 13.216 21.091 13.5938 20.625 13.5938C20.159 13.5938 19.7812 13.216 19.7812 12.75V9.375C19.7812 7.35474 18.1453 5.71875 16.125 5.71875H13.875Z",
    fill: "#1E1542"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0312 17.25C13.0312 16.784 13.409 16.4062 13.875 16.4062H16.125C16.591 16.4062 16.9688 16.784 16.9688 17.25C16.9688 17.716 16.591 18.0938 16.125 18.0938H13.875C13.409 18.0938 13.0312 17.716 13.0312 17.25Z",
    fill: "#1E1542"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.4062C15.466 16.4062 15.8438 16.784 15.8438 17.25V20.625C15.8438 21.091 15.466 21.4688 15 21.4688C14.534 21.4688 14.1562 21.091 14.1562 20.625V17.25C14.1562 16.784 14.534 16.4062 15 16.4062Z",
    fill: "#1E1542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.c1fe8c2e12c036932fa01b036cbd3c92.svg";
export { ForwardRef as ReactComponent };